import { TS_TC } from '../TravelSeller/Models/TS_TC';

export class TC extends TS_TC{
}